import React, { useEffect, useState } from 'react';
import Sidebar from '../Sidebar';
import { Gheader } from '../Gheader';
import styles from '../Guest.module.css';
import FilterButton from '../FilterButton';
import InvoicesTable from './InvoicesTable';
import GuestModel from '../GuestModel';
import apiService from '../../api/apiService';

export const Invoices = () => {
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const addInvoice = newInvoice => {
    setInvoices([newInvoice, ...invoices]);
  };

  useEffect(() => {
    fetchInvoices();
  }, []);

  const fetchInvoices = async () => {
    try {
      const response = await apiService.get('/invoices/');
      console.log(response);
      setInvoices(response);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={styles.gheader}>
      <div className={styles.dashboardContainer}>
        <Sidebar />
        <div className={styles.mainContent}>
          <Gheader />
          <h3>Invoices</h3>
          {/* <div className={styles.buttonContainer}>
            <button
              className={styles.addGuestButton}
              onClick={() => setIsModelOpen(true)}
            >
              Add Guests
            </button>
            <FilterButton />
          </div> */}

          <InvoicesTable data={invoices} setData={setInvoices} />

          {isModelOpen && (
            <GuestModel
              isOpen={isModelOpen}
              onClose={() => setIsModelOpen(false)}
              onSave={addInvoice}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Invoices;
